import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom'

import Footer from '../../common/footer'
import { footerProps, defaultFooterProps } from '../../common/utils/constant';
import MainHeader from '../../common/components/main-header';
import { useAppContext } from '../../common/context';

function MainLayout() {
  const location = useLocation();
  const currentPath = location.pathname;
  const { notification } = useAppContext();
  const [data, setData] = useState(defaultFooterProps);
  useEffect(() => {
    const footerParam = footerProps.filter(item => item.screen === currentPath);
    if (footerParam) {
      setData(footerParam[0])
    }
  }, [currentPath]);
  
  useEffect(() => {
    if (!data) {
      setData(defaultFooterProps)
    }
  }, [data])

    return (
    <>
      <MainHeader/>
      <main className={`${notification ? 'notification-main-head' : 'main-head-pad'} `}> <Outlet /></main>
      <Footer data={data} />
    </>

  )
}

export default MainLayout

export function SectionWrapper(props) {
  return (
    <div className='test'>
    <div className="global-section-wrapper" style={{
      backgroundColor: props.bg ? props.bg : '#FFF',
    }} {...props}>
      <div className="px-0 main-wrapper">
        {props.children}
      </div>
    </div>
    </div>
  )
}